module.exports = __webpack_public_path__ + "img/four-pay-icon.5cb94af6.svg";